export default __webpack_public_path__ + "static/media/Screenshot_1.a2e6804e.png";